import type { ReactNode } from 'react'
import { forwardRef } from 'react'

interface Props {
  id: string
  eyebrow: string
  title: string
  volume: string
  highlighted: boolean
  children: ReactNode
}

const SolverCard = forwardRef<HTMLElement, Props>(({ id, eyebrow, title, volume, highlighted, children }, ref) => {
  return (
    <section
      ref={ref}
      id={id}
      className={`glass glow-border rounded-2xl p-6 md:p-8 scroll-mt-28 ${highlighted ? 'calc-highlight' : ''}`}
    >
      <header className="flex items-start justify-between gap-4 mb-6">
        <div>
          <div className="text-[11px] uppercase tracking-[0.18em] text-emerald-300/80 font-medium">{eyebrow}</div>
          <h2 className="font-display text-2xl md:text-3xl font-semibold mt-1.5 text-white">{title}</h2>
        </div>
        <span className="shrink-0 text-[11px] font-mono-math text-slate-400 px-2.5 py-1 rounded-md border border-[var(--line)] bg-white/[0.02]">
          {volume}
        </span>
      </header>
      {children}
    </section>
  )
})

SolverCard.displayName = 'SolverCard'

export default SolverCard
